/* eslint-disable no-console */
import type { Plugin } from '@nuxt/types';
import { willSendToSentry } from './utils';
import type { pushError } from './types';
import type { Auth } from '~/types/plugins';

/**
 * Plugin extends functionality of a main $sentry plugin by $sentryUtils
 * set user, provide easy way to send errors
 */
const sentryPlugin: Plugin = ({ app }, inject) => {
  if (app.$sentry) {
    // Set user info for sentry
    const setUser = (auth: Auth) => {
      const user = auth?.user;
      const person = user?.id ? { id: user.id, email: user.email, username: user.autoName } : null;

      if (person) {
        app.$sentry.setUser(person);
      }
    };
    app.store?.watch(store => store.auth, setUser, { immediate: true });

    // Set context tag
    app.$sentry.setTag('context', process.client ? 'client' : 'server');
  }

  const pushError: pushError = (error, data) => {
    const statusCode = error.response?.status || error.status;
    const message = error.response?.statusText || error.statusText || error.message;
    let fullstoryLink: string | null | undefined;

    if (typeof data === 'string') {
      // eslint-disable-next-line
      data = {
        info: data,
      };
    }

    if (process.client) {
      try {
        fullstoryLink = window.FS?.getCurrentSessionURL();
      } catch (e) {}
    }

    if (app.$sentry) {
      if (willSendToSentry(error)) {
        app.$sentry.captureException(error, {
          extra: {
            statusCode,
            message,
            ...(fullstoryLink && { fullstoryLink }),
            ...data,
          },
        });
      }
    } else {
      console.error(error);
    }

    return { statusCode, message };
  };

  inject('sentryUtils', {
    error: pushError,
  });
};

export default sentryPlugin;
